// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b2f88cad","453":"45582423","455":"da790131","977":"d61c4791"}[chunkId] + ".chunk.js";
};